var map = {
	"./de/cv-play.png": "+DKn",
	"./en/cv-play.png": "pb3b",
	"./es/cv-play.png": "UxHq",
	"./fr/cv-play.png": "Noe7",
	"./ja/cv-play.png": "SomK",
	"./ko/cv-play.png": "/dyp",
	"./pt/cv-play.png": "V2kn",
	"./ru/cv-play.png": "clWZ",
	"./tc/cv-play.png": "XivI",
	"./th/cv-play.png": "yQz4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "/MV6";